import { render, staticRenderFns } from "./PageUserBookings.vue?vue&type=template&id=1ed708ad"
import script from "./PageUserBookings.vue?vue&type=script&lang=js"
export * from "./PageUserBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports